<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-06-23 16:17:26
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-19 18:02:29
-->
<template>
  <!--  :style="{ height: height, overflow: 'auto' }"-->
  <div class="content px-6 pt-6"
       :style="{'height': height, overflow: 'auto' }">
    <!-- 面包屑 -->
    <div v-if="$route.name == 'dashboard'">
      <div class="showBox"
           :style="{ minHeight: height.replace('px', '') - 70 + 'px' }">
        <router-view class="routerView"></router-view>
      </div>
    </div>
    <div v-else>
      <!-- <breadcrumbs /> -->
      <div class="pageTitle d-flex">
        {{change($route.meta.title)}}
        <div style="opacity: 0;width:0;height:0;">
          {{change($store.state.page_title)}}
        </div>
      </div>
      <!-- <div class="showBox" 
           :style="{ minHeight: height.replace('px', '') - 200 + 'px' }"> -->
      <div :style="{'min-height':height2}">
        <router-view class="routerView"></router-view>
      </div>
      <div class="text-center"
           style="font-size:12px;color:rgba(0,0,0,0.38);height:30px;line-height:30px;">
        © {{ new Date().getFullYear() }} MRC International Group Limited. All
        rights reserved.
        <a href="https://privacy.essencehr.io/"
           target="_blank"
           style="color:var(--main-color);text-decoration: none">Privacy Policy</a>
        and
        <a href="https://terms.essencehr.io/"
           target="_blank"
           style="color:var(--main-color);text-decoration: none">Term of Use.</a>
      </div>
    </div>
    <!-- <div class="text-center"
         style="font-size:12px;color:rgba(0,0,0,0.38);height:30px;line-height:30px;">
      © {{ new Date().getFullYear() }} MRC International Group Limited. All
      rights reserved.
      <a href="https://privacy.essencehr.io/"
         target="_blank"
         style="color:var(--main-color);text-decoration: none">Privacy Policy</a>
      and
      <a href="https://terms.essencehr.io/"
         target="_blank"
         style="color:var(--main-color);text-decoration: none">Term of Use.</a>
    </div> -->
  </div>
</template>

<script>
import breadcrumbs from './breadcrumds'
export default {
  components: {
    breadcrumbs,
  },
  props: {},
  data () {
    return {
      breadList: [], // 路由集合
      contentHeightMoreWindowHeight: false,
      levelList: [],
    }
  },
  created () { },
  mounted () {
  },
  methods: {
    change (val) {
      let title = ''
      if (Array.isArray(val)) {
        title = this.INT(val)
      }
      else {
        title = this.$t(val)
      }
      return title
    },
  },
  computed: {
    menuList () {
      return this.$store.state.sideMenu
    },
    height2 () {
      // return (Number(this.$store.state.calcHeight.replace('px', '')) - 50) + 'px'
      return (Number(this.$store.state.calcHeight.replace('px', '')) - 21 - 90 - 24 - 30) + 'px'
    },
    height () {
      return this.$store.state.calcHeight
    },
    // title () {
    //   let title = ''
    //   if (Array.isArray(this.$route.meta.title)) {
    //     title = this.INT(this.$route.meta.title)
    //   }
    //   else {
    //     title = this.$t(this.$route.meta.title)
    //   }
    //   return title
    // },
  },
  watch: {
  },
}
</script>

<style scoped>
.content {
  position: relative;
  /* height: 75%; */
  overflow: hidden;
  /* padding-bottom: 10px; */
  background-color: #eeeef0;
  /* overflow: hidden; */
  margin: 0 auto;
  /* height: 100%; */
  max-width: 1600px;
}
/* .routerView {
  margin-top: 30px;
} */
.content .pageTitle {
  /* font-size: 20px; */
  /* font-weight: bold; */
  /* text-align: left; */
  padding: 24px 0;
  font-family: var(--body-font-family);
  font-style: normal;
  font-weight: normal;
  font-size: 28px;
  color: rgba(0, 0, 0, 0.78);
}
</style>
